import { makeStyles } from '@material-ui/core';
import LinuxellLogo from './linuxell-logo.png';

const useStyles = makeStyles({
  img: {
    width: 32,
    height: 32,
    objectFit: 'cover',
    objectPosition: 'left',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img className={classes.img} src={LinuxellLogo} alt="Lx" />;
};
